export default __webpack_public_path__ + "images/sweep4.1a365b79c3c9232738dddb4f2f207c93.gif";